import request from '@/utils/request';

//修改用户信息
export const userUpdate = (userInfo) => {
    return request.post('/user/update', {
        ...userInfo
    })
}

// 头像上传七牛云
export const QinniuToken = () => {
    // 获取七牛的token
    return new Promise((resolve, reject) => {
        request.post('/qiniu/token').then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

//获取访问量
export const statistics = () => {
    return request.get('/statistics/summary')
}
